import { TFunction } from 'i18next';
import { DiscountRequestNotification, NotificationType } from 'interfaces';
import {
  formatDate,
  getDiscountRequestStatusNotificationMessage,
  getDiscountRequestStatusText,
} from 'utils';

export const getNotificationCardTitle = (
  t: TFunction,
  notification: DiscountRequestNotification,
) => {
  switch (notification.notificationType) {
    case NotificationType.STATUS_CHANGED:
      return getDiscountRequestStatusText(notification.status, false);
    case NotificationType.ASSIGNED_TO_YOU:
      return t('serviceNotifications.discountRequest.assignment');
    case NotificationType.ASSIGNED_TO_ANOTHER:
      return t('serviceNotifications.discountRequest.unassignment');
    default:
      return undefined;
  }
};

export const getNotificationCardDescription = (
  t: TFunction,
  notification: DiscountRequestNotification,
) => {
  switch (notification.notificationType) {
    case NotificationType.STATUS_CHANGED:
      return getDiscountRequestStatusNotificationMessage({
        status: notification.status,
        formattedDate: formatDate(notification.createdDate),
        companyName:
          notification.companyName && `“${notification.companyName}”`,
      });
    case NotificationType.ASSIGNED_TO_YOU:
      return t('serviceNotifications.discountRequest.message.assigned', {
        title: notification.companyName,
      });
    case NotificationType.ASSIGNED_TO_ANOTHER:
      return t('serviceNotifications.discountRequest.message.unassigned', {
        name: notification.user?.login,
        title: notification.companyName,
      });
    default:
      return undefined;
  }
};
